import Vuex from 'vuex';

const state = {
  opened: false,
};

const getters = {
  isOpened: state => state.opened,
};

const actions = {
  toggleSearch: ({ state, commit, dispatch }) => {
		commit('doToggleSearch');
  }
};

const mutations = {
  doToggleSearch: (state) => {
    state.opened = !state.opened;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./store/modules/search.js